import React from 'react'

const Pagination = (props) => {
    const {
        current_pages, 
        limit, 
        total_data_count, 
        total_pages, 
        data_length
    } = props.pagination_data;

    var showing_to = ( (parseInt(current_pages) -1) * parseInt(limit)) + 1;
    var showing_from = (showing_to + data_length) - 1;

    return (
        <>
            <div className="d-flex flex-stack flex-wrap pt-5">
                <div className="fs-6 fw-bold text-gray-700">
                    Showing {showing_to} to {showing_from} of {total_data_count} entries
                </div>
                <ul className="pagination">
                    <li className={`page-item ${current_pages == 1 && 'disabled'}`}>
                        <div className="page-link">
                            <i 
                                className="previous"
                                onClick={() => props.onClick('','previous')}
                            ></i>
                        </div>
                    </li>

                    {Array.from({ length: total_pages }, (_, index) => (
                        <li className="page-item" key={index + 1}>
                            <a 
                                href="#" 
                                className={`page-link ${current_pages == index+1 && 'active'}`}
                                onClick={(e) => { e.preventDefault(); props.onClick(index + 1,'page'); }}
                            >
                                {index + 1}
                            </a>
                        </li>
                    ))}
                    <li className={`page-item ${current_pages == total_pages && 'disabled'}`}>
                        <div className="page-link">
                            <i 
                                className="next"
                                onClick={() => props.onClick('','next')}
                            ></i>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Pagination